import { InjectionToken } from '@angular/core';
import { BuildInfo } from '@viso/core/models';

export const BUILD_INFO = new InjectionToken<BuildInfo>(null);
